import { useState } from "react";

const useConfirmationModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [actionId, setActionId] = useState(null);

  const openModal = (id) => {
    setActionId(id);
    setIsOpen(true);
  };

  const closeModal = () => {
    setActionId(null);
    setIsOpen(false);
  };

  return {
    isOpen,
    actionId,
    openModal,
    closeModal,
  };
};

export { useConfirmationModal }
// import { useState } from "react";

// const useConfirmationModal = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [actionId, setActionId] = useState(null);
//   const [config, setConfig] = useState({
//     title: '',
//     message: '',
//     btnText: 'Delete',
//     onConfirm: () => {},
//   });

//   const openModal = ({ id = null, title, message, onConfirm }) => {
//     setActionId(id);
//     setConfig({ title, message, onConfirm });
//     setIsOpen(true);
//   };

//   const closeModal = () => {
//     setActionId(null);
//     setConfig({ title: '', message: '', onConfirm: () => {} });
//     setIsOpen(false);
//   };

//   return {
//     isOpen,
//     actionId,
//     title: config.title,
//     message: config.message,
//     onConfirm: config.onConfirm,
//     btnText: config.btnText,
//     openModal,
//     closeModal,
//   };
// };

// export { useConfirmationModal };